/**
 * Mega Menu Hover Fix
 * Verhindert, dass das Mega-Menü zu schnell schließt
 */

document.addEventListener('DOMContentLoaded', function() {
  const megaMenuTriggers = document.querySelectorAll('.mega-menu-trigger');

  megaMenuTriggers.forEach(trigger => {
    const panel = trigger.querySelector('.mega-menu-panel');
    const link = trigger.querySelector('.mega-menu-trigger__link');
    if (!panel) return;

    let closeTimeout;
    let isOpen = false;

    function openPanel() {
      clearTimeout(closeTimeout);
      isOpen = true;
      panel.style.opacity = '1';
      panel.style.visibility = 'visible';
      panel.style.pointerEvents = 'all';
      panel.style.transition = 'opacity 0.2s ease';
    }

    function closePanel() {
      isOpen = false;
      panel.style.opacity = '0';
      panel.style.visibility = 'hidden';
      panel.style.pointerEvents = 'none';
    }

    function scheduleClose() {
      clearTimeout(closeTimeout);
      closeTimeout = setTimeout(() => {
        if (!panel.matches(':hover') && !link.matches(':hover')) {
          closePanel();
        }
      }, 300); // Erhöhte Verzögerung auf 300ms
    }

    // Events auf Link
    link.addEventListener('mouseenter', openPanel);
    link.addEventListener('mouseleave', scheduleClose);

    // Events auf Trigger
    trigger.addEventListener('mouseenter', openPanel);
    trigger.addEventListener('mouseleave', scheduleClose);

    // Events auf Panel
    panel.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      isOpen = true;
    });

    panel.addEventListener('mouseleave', scheduleClose);

    // Schließe alle anderen Panels
    trigger.addEventListener('mouseenter', () => {
      document.querySelectorAll('.mega-menu-panel').forEach(otherPanel => {
        if (otherPanel !== panel) {
          otherPanel.style.opacity = '0';
          otherPanel.style.visibility = 'hidden';
          otherPanel.style.pointerEvents = 'none';
        }
      });
    });
  });
});
